export const DEFAULT_VALUE_VALIDITY_YEARS = 1;
